import React, { useState } from 'react'
import { Alert, Button, Modal, Spinner } from 'react-bootstrap'
import { ICronJob } from '../../../models/ICronJob';
import { useDeleteCronJobMutation } from '../../../store/api/cronJobsApi';

type DeleteCronJobModalProps = {
    cronJob: ICronJob;
    show: boolean;
    onHide: () => void;
    onSuccess: () => void;
}

const defaultErrorMsg = 'Oops. Something went wrong. Please, try again later. ';

const DeleteCronJobModal: React.FC<DeleteCronJobModalProps> = ({ cronJob, show, onHide, onSuccess }) => {

    const [errorMsg, setErrorMsg] = useState<string | null>(null);
    const [deleteCronJob, { isLoading }] = useDeleteCronJobMutation();

    const onModalHide = () => {
        setErrorMsg(null);
        onHide();
    }

    const onDeleteClick = async () => {
        const deleteResponse = await deleteCronJob(cronJob.id);

        if ('error' in deleteResponse) {
            const err = deleteResponse.error as any;
            setErrorMsg(err.data?.message || defaultErrorMsg);
        }
        else {
            setErrorMsg(null);
            onSuccess();
        }
    }

    return (
        <Modal
            centered
            show={show}
            onHide={onModalHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Delete Cron Job
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMsg && <Alert variant='danger' onClose={() => setErrorMsg(null)} dismissible>
                    {errorMsg}
                </Alert>}

                Are you sure you want to delete {cronJob.title} ({cronJob.alias})? This action cannot be undone.
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={onModalHide}>Cancel</Button>
                <Button variant='danger' onClick={onDeleteClick} disabled={isLoading}>
                    {isLoading && <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true" />}
                    <span className="sr-only">Delete</span>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteCronJobModal
